// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Accordion, ActionIcon, Center, Text } from '@mantine/core';
import { IconChevronRight, IconFileDescription, IconTrash } from '@tabler/icons';
import { useContext } from 'react';
import { ContractTemplateContext } from '../../Service/Context/ContractTemplateContext';
import { ContractTemplateBlockButtons } from './AddBlockButtons';

const ContractTemplateDocumentBlock = () => {
  const { removePositions } = useContext(ContractTemplateContext);

  return (
    <>
      <Accordion
        variant="separated"
        chevronPosition="left"
        chevron={<IconChevronRight size="1rem" />}
        styles={{
          chevron: {
            '&[data-rotate]': {
              transform: 'rotate(90deg)',
            },
          },
        }}
        sx={{
          flexGrow: 1,
        }}
      >
        <Accordion.Item value="1">
          <Center>
            <Accordion.Control>
              <IconFileDescription size={20} style={{ marginRight: 10, marginTop: -3 }} /> Dokument
            </Accordion.Control>
            <IconTrash
              size={20}
              style={{ cursor: 'pointer', marginRight: 10 }}
              className="hooverable-icon"
              onClick={removePositions}
            />
          </Center>
          <Accordion.Panel>
            <Text italic color="dimmed">
              Positionen werden hier aus einem ausgewählten Dokument eingefügt.
            </Text>
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
      <ContractTemplateBlockButtons isAbove={false} />
    </>
  );
};

export default ContractTemplateDocumentBlock;
